import { SEO } from "../components/SEO";
import { Reveal, Eyebrow } from "../components/Reveal";

function LegalLayout({ eyebrow, title, children, path, desc }) {
  return (
    <>
      <SEO title={title} description={desc} path={path} />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
        <Reveal>
          <Eyebrow>{eyebrow}</Eyebrow>
          <h1 className="mt-3 font-display text-4xl font-black uppercase tracking-tight text-slate-50 sm:text-5xl">
            {title}
          </h1>
          <div className="mt-8 space-y-6 text-sm leading-relaxed text-slate-300">{children}</div>
        </Reveal>
      </section>
    </>
  );
}

export function WarrantyPage() {
  return (
    <LegalLayout
      eyebrow="Our Promise"
      title="Warranty Information"
      path="/warranty"
      desc="My Mobile Mechanic backs qualifying repairs with a 3-year / 36,000-mile parts-and-labor warranty when we supply the parts."
    >
      <p>
        When My Mobile Mechanic supplies the parts, your repair is backed by a{" "}
        <strong className="text-slate-50">3-year / 36,000-mile parts-and-labor warranty</strong> —
        whichever comes first — in writing with your invoice.
      </p>
      <h2 className="font-display text-xl font-bold uppercase text-slate-50">What's covered</h2>
      <p>
        Defects in the brake pads, rotors, calipers, bearings, suspension components and other parts
        we supply and install, plus the labor to replace them, under normal driving conditions.
      </p>
      <h2 className="font-display text-xl font-bold uppercase text-slate-50">How it works</h2>
      <p>
        If something we installed fails under normal use, call or text us with your invoice and we'll
        come back and make it right. Your old parts are always shown to you or left with you after
        every job.
      </p>
      <h2 className="font-display text-xl font-bold uppercase text-slate-50">What's not covered</h2>
      <p>
        Customer-supplied parts (labor-only coverage applies), normal wear over time, damage from
        accidents or misuse, and pre-existing issues in parts of the vehicle we didn't service. Full
        warranty terms are provided in writing with your invoice.
      </p>
    </LegalLayout>
  );
}

export function PrivacyPage() {
  return (
    <LegalLayout
      eyebrow="Your Data"
      title="Privacy Policy"
      path="/privacy"
      desc="How My Mobile Mechanic handles the information you share when requesting quotes and booking service."
    >
      <p>
        When you request a quote or book an appointment, we collect the information needed to serve
        you: your name, phone number, email, vehicle details and service location.
      </p>
      <h2 className="font-display text-xl font-bold uppercase text-slate-50">How we use it</h2>
      <p>
        Only to prepare your quote, perform your repair, and communicate about your appointment. We
        do not sell your information to anyone.
      </p>
      <h2 className="font-display text-xl font-bold uppercase text-slate-50">Payments</h2>
      <p>
        This website never stores raw credit card numbers. When online deposits and pre-payment
        launch, card processing will be handled entirely by a secure, PCI-compliant payment provider.
      </p>
      <h2 className="font-display text-xl font-bold uppercase text-slate-50">Analytics</h2>
      <p>
        We use privacy-respecting site analytics to understand how visitors find and use the site so
        we can improve it. Questions? Call us anytime.
      </p>
    </LegalLayout>
  );
}

export function TermsPage() {
  return (
    <LegalLayout
      eyebrow="The Fine Print"
      title="Terms of Service"
      path="/terms"
      desc="Terms of service for booking mobile automotive repair with My Mobile Mechanic."
    >
      <p>
        By booking an appointment with My Mobile Mechanic, you agree to the following terms.
      </p>
      <h2 className="font-display text-xl font-bold uppercase text-slate-50">Appointments</h2>
      <p>
        Time slots are arrival windows. Please ensure the vehicle is accessible, parked on a
        reasonably firm and level surface, with working room around it. If we can't safely perform
        the work on arrival, the appointment may need to be rescheduled.
      </p>
      <h2 className="font-display text-xl font-bold uppercase text-slate-50">Quotes & payment</h2>
      <p>
        Quotes are based on the vehicle information you provide and are confirmed before work
        begins. Payment is due when the job is complete unless a deposit or pre-payment arrangement
        has been made in advance.
      </p>
      <h2 className="font-display text-xl font-bold uppercase text-slate-50">Cancellations</h2>
      <p>
        Life happens — call us as soon as you can if you need to move your appointment, and we'll
        find you a new slot.
      </p>
    </LegalLayout>
  );
}
